import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from '~/plugins/Moment.js';
import axios from '~/plugins/axios.js';
export default {
  name: 'ViewSessionDetailsOfDay',
  data: function data() {
    return {
      statusStyle: {
        backgroundColor: '#565656',
        padding: '10px',
        color: '#efefef'
      },
      detailTableFields: [{ key: 'count', label: 'No' }, { key: 'user.fullname', label: 'Name' }, { key: 'user.nricFin', label: 'NRIC/FIN' }, {
        key: 'user.workingProfile.Work_Permit_Expiry',
        label: 'WorkPermit.Exp'
      }, { key: 'user.companyName', label: 'Company', sortable: true }, {
        key: 'user.workingProfile.ECSOC_Expiry',
        label: 'CSOC'
      }, { key: 'remarkStatus', label: 'Remark' }, { key: 'action', label: 'Action' }],

      details: null,
      moduleSessionId: null,
      remarkInput: null
    };
  },

  methods: {
    printContent: function printContent(id) {
      printJS(id, 'html');
      console.log('\n\n ====== ViewSessionDetailsOfDay <|-- printContent() ===== \n');
    },


    // ============ CANCEL BOOKING ==============
    cancelBooking: function cancelBooking() {
      var userActorId = this.details.item.user.id;
      var moduleSessionActorId = this.moduleSessionId;
      var remark = this.remarkInput;

      var removeWorker = axios.post('/userMsManager/cancelPendingAttend', {
        userActorId: userActorId,
        moduleSessionActorId: moduleSessionActorId,
        remark: remark
      });
      var cancelSeat = axios.post('/moduleSession/cancelSeat', {
        moduleSessionActorId: moduleSessionActorId
      });

      window.location.reload();

      // console.log(this.details.item.user.id);
      // console.log(this.moduleSessionId);
      // console.log(this.remarkInput);
    },
    popRemoveModal: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(button, row, msid_index, time, msIdArr) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$root.$emit('bv::show::modal', 'cancelBookingModal', button, row);
                this.details = row;
                this.moduleSessionId = msid_index;
                // console.log(msIdArr);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function popRemoveModal(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return popRemoveModal;
    }(),

    flatten: function flatten(obj) {
      var root = {};
      (function tree(obj, index) {
        var suffix = toString.call(obj) == "[object Array]" ? "]" : "";
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) continue;
          root[index + key + suffix] = obj[key];
          if (toString.call(obj[key]) == "[object Array]") tree(obj[key], index + key + suffix + "[");
          if (toString.call(obj[key]) == "[object Object]") tree(obj[key], index + key + suffix + ".");
        }
      })(obj, "");
      return root;
    },

    sortCompareAdvanced: function sortCompareAdvanced(a, b, key) {
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
      } else {
        if (this.flatten(a).hasOwnProperty(key) && this.flatten(b).hasOwnProperty(key)) {
          // Stringify the field data and use String.localeCompare
          return this.flatten(a)[key].toString().localeCompare(this.flatten(b)[key].toString(), undefined, {
            numeric: true
          });
        } else {
          if (this.flatten(a).hasOwnProperty(key) && !this.flatten(b).hasOwnProperty(key)) {
            return -1;
          }
          return 1;
        }
      }
    },

    // ============ REVERT ATTENDANCE ==============
    revertAttendance: function revertAttendance(abc, row, msid_index) {
      console.log(abc);
      console.log(row);
      console.log(msid_index);
      var userActorId = row.item.user.id;
      var moduleSessionActorId = msid_index;
      var revertStatus = axios.post('/userMsManager/revertStatus', {
        userActorId: userActorId,
        moduleSessionActorId: moduleSessionActorId
      });

      window.location.reload();

      //console.log(this.moduleSessionId);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/viewingInfo/ViewSessionDetailsOfDay.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/viewingInfo/ViewSessionDetailsOfDay.vue
// module chunks = 2